<template>
    <el-table
        :data="signInTable"
        ref="SignInTable"
        border
        class="performanceSignInTable"
        :cell-style="rowStyle"
        :height="height"
    >
        <el-table-column
            label="商品行号"
            prop="lineNo"
            show-overflow-tooltip
            align="center"
            width="100px"
        ></el-table-column>
        <el-table-column
            label="商品编码"
            prop="itemCode"
            align="center"
            show-overflow-tooltip
            width="150px"
        ></el-table-column>
        <el-table-column
            label="商品名称"
            prop="itemName"
            align="center"
            show-overflow-tooltip
            width="250px"
        ></el-table-column>
        <el-table-column
            label="商品状态"
            prop="itemStatusName"
            align="center"
            show-overflow-tooltip
            width="100px"
        ></el-table-column>
        <el-table-column
            v-if="rowData.sourceSystem === 'BELLE-WBKH'"
            label="上游商品行号"
            align="center"
            prop="upperLineNo"
            show-overflow-tooltip
            width="190px"
        ></el-table-column>
        <el-table-column
            v-if="rowData.sourceSystem === 'TAIJI-WBKH'"
            label="包件数"
            align="center"
            prop="pkgQty"
            show-overflow-tooltip
            width="100px"
        ></el-table-column>
        <el-table-column label="正品" prop="realReceive" show-overflow-tooltip align="center">
            <template slot-scope="scope">
                <el-input
                    v-model.trim="scope.row.realReceive"
                    v-if="signTableFieldIsEdit.realReceive"
                    @input="
                        computedSignPushRealReceiveCount(
                            scope.row,
                            'realReceive'
                        )
                    "
                    class="customTableColumnInput"
                />
                <div class="notEdit" v-else>
                    {{
                    (scope.row.realReceive = handleComputedRealReceiptCount(
                    scope.row
                    ))
                    }}
                </div>
            </template>
        </el-table-column>
        <el-table-column label="污染" prop="mildewPolluteCount" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
                <el-input
                    v-model="scope.row.mildewPolluteCount"
                    v-if="signTableFieldIsEdit.mildewPolluteCount"
                    @input="
                        onlyInputNonnegativeInteger(
                            scope.row,
                            'mildewPolluteCount'
                        )
                    "
                    class="customTableColumnInput"
                />
                <div v-else>{{ scope.row.mildewPolluteCount }}</div>
            </template>
        </el-table-column>
        <el-table-column label="破损" align="center" prop="packageDamagedCount" show-overflow-tooltip>
            <template slot-scope="scope">
                <el-input
                    v-model="scope.row.packageDamagedCount"
                    v-if="signTableFieldIsEdit.packageDamagedCount"
                    @input="
                        onlyInputNonnegativeInteger(
                            scope.row,
                            'packageDamagedCount'
                        )
                    "
                    class="customTableColumnInput"
                />
                <div v-else>{{ scope.row.packageDamagedCount }}</div>
            </template>
        </el-table-column>
        <el-table-column label="短少" align="center" prop="stockoutCount" show-overflow-tooltip>
            <template slot-scope="scope">
                <el-input
                    v-model="scope.row.stockoutCount"
                    v-if="signTableFieldIsEdit.stockoutCount"
                    @input="
                        onlyInputNonnegativeInteger(scope.row, 'stockoutCount')
                    "
                    class="customTableColumnInput"
                />
                <div v-else>{{ scope.row.stockoutCount }}</div>
            </template>
        </el-table-column>
        <el-table-column label="拒收" prop="rejectQty" show-overflow-tooltip align="center">
            <template slot-scope="scope">
                <el-input
                    v-model="scope.row.rejectQty"
                    v-if="signTableFieldIsEdit.rejectQty"
                    @input="onlyInputNonnegativeInteger(scope.row, 'rejectQty')"
                    class="customTableColumnInput"
                />
                <div v-else>{{ scope.row.rejectQty }}</div>
            </template>
        </el-table-column>
        <el-table-column label="备注" show-overflow-tooltip width="150px" align="center">
            <template slot-scope="scope">
                <el-input
                    v-model.trim="scope.row.signRemark"
                    style="width: 100%"
                    class="customTableColumnInput"
                    v-if="signTableFieldIsEdit.signRemark"
                ></el-input>
                <div v-else>{{ scope.row.signRemark }}</div>
            </template>
        </el-table-column>
    </el-table>
</template>
<script>
import _ from 'lodash';
import { OPERATE_TYPE } from '../utils/constant.js';
import { sum, subtraction, computedRealReceiptCount, numInputLimit, tableFieldIsEdit } from './util.js';
export default {
    name: 'signInTable',
    props: {
        rowData: {
            type: Object,
            default () {
                return {};
            }
        },
        tableDataList: {
            type: Array,
            default () {
                return [];
            }
        },
        kaType: { // 苏宁订单时，不能操作破损
            type: String,
            default: ''
        },
        operateType: { // 操作类别
            type: String,
            default: ''
        },
        height: {
            type: Number,
            default: 320
        }
    },
    data () {
        return {
            signInTable: [],
            signTableFieldIsEdit: { // 定制化签收表格字段是否可编辑，默认（正品、污染、破损、短少、拒收、备注）等字段都不可编辑
                realReceive: false,
                mildewPolluteCount: false,
                packageDamagedCount: false,
                stockoutCount: false,
                rejectQty: false,
                signRemark: false
            }
        };
    },
    methods: {
        /**
         * @description 表格居中样式
         */
        rowStyle () {
            return 'text-align:center';
        },
        /**
         * @description 初始化回单签收表格数据
         */
        initTableData () {
            this.signInTable = JSON.parse(JSON.stringify(this.tableDataList));
            if (this.operateType === OPERATE_TYPE.REJECT_COMFIRM) {
                this.signInTable.forEach(v => {
                    v.rejectQty = computedRealReceiptCount(v);
                });
            }
        },

        /**
         * @description 计算正品数量，回单拒收时，正品数量为0, 拒收数量为全部
         * @param {Object} row 当前操作行数据
         */
        handleComputedRealReceiptCount (row) {
            return this.operateType === OPERATE_TYPE.REJECT_COMFIRM ? 0 : computedRealReceiptCount(row);
        },

        /**
         * @description 只能输入非负整数
         * @param {Object} row 当前操作行数据
         * @param {String} prop 当前操作目标字段
         */
        onlyInputNonnegativeInteger (row, prop) {
            row[prop] = numInputLimit(row, prop);
            // 如果是签收重推，重新计算正品数量
            if (this.operateType === OPERATE_TYPE.SIGN_PUSH) {
                row.realReceive = computedRealReceiptCount(row);
            }
            this.$emit('setCount', this.signInTable);
        },

        /**
         * @description 计算签收重推时的正品数量
         * @param {Object} row 当前操作行数据
         * @param {String} prop 当前操作目标字段
         */
        computedSignPushRealReceiveCount (row, prop) {
            row[prop] = numInputLimit(row, prop); // 只能输入数字
            const sumNum = sum([row.mildewPolluteCount, row.packageDamagedCount, row.stockoutCount, row.realReceive]);
            row.rejectQty = subtraction(row.realDeliverCount, sumNum); // 拒收数量 = 实发数量 - (污染 + 破损 + 短少 + 正品)
        },

        /**
         * @description 组装数据
         */
        formatReqParams () {
            const params = this.signInTable.map(v => {
                return {
                    abnormalCount: sum([v.mildewPolluteCount, v.packageDamagedCount, v.stockoutCount, v.rejectQty]) || 0, // 总异常数量
                    id: v.id, // 商品id
                    custItemCode: v.custItemCode, // 客户商品编码
                    itemCode: v.itemCode, // 商品编码
                    itemName: v.itemName, // 商品名称
                    itemStatus: v.itemStatus, // 商品状态
                    itemSuiteCode: v.itemSuiteCode, // 套机编码
                    lineNo: v.lineNo, // 商品行号
                    mildewPolluteCount: v.mildewPolluteCount || 0, // 霉变污染
                    packageDamagedCount: v.packageDamagedCount || 0, // 包装破损
                    stockoutCount: v.stockoutCount || 0, // 货物短少
                    rejectQty: v.rejectQty || 0, // 拒收数量
                    realDeliverCount: v.realDeliverCount || 0, // 实发数量
                    realReceiveCount: sum([v.realReceive, v.packageDamagedCount, v.mildewPolluteCount]) || 0, // 实收数量
                    realReceive: v.realReceive || 0, // 正品数量
                    signRemark: v.signRemark, // 备注
                    taskNo: this.rowData.taskNo, // 运输单号
                    upperLineNo: v.upperLineNo, // 上游商品行号
                    version: v.version || 0
                };
            });
            return params;
        },

        /**
         * @description 校验正品数量是否大于0，拒收确认时，备注必填
         */
        validateDataIsTrue () {
            return new Promise((resolve, reject) => {
                const flag = this.signInTable.every(v => v.realReceive >= 0); // 正品是否大于等于0
                const signRemarkIsNull = this.signInTable.some(v => !v.signRemark); // 备注是否为空（拒收确认时，备注必填）
                if (!flag) {
                    reject(new Error('正品数量不能为负数！'));
                } else if (this.operateType === OPERATE_TYPE.REJECT_COMFIRM && signRemarkIsNull) {
                    reject(new Error('备注不能为空！'));
                } else {
                    resolve(this.formatReqParams());
                }
            });
        }
    },
    mounted () {
        // 对初始对象中的数值进行操作时，先拷贝，在赋值，避免数据污染
        const copyTableFieldIsEdit = _.cloneDeep(tableFieldIsEdit[this.operateType]);
        // 来源系统=CAINIAO，订单来源平台=菜鸟天猫优品的订单在签收中心操作签收时，不允许操作拒收
        if (this.rowData.sourceSystem === 'CAINIAO' && this.rowData.orderSourcePlatform === 'tmYp') {
            copyTableFieldIsEdit.rejectQty = false;
        }
        this.signTableFieldIsEdit = copyTableFieldIsEdit;
    },
    watch: {
        kaType (val) {
            // 签收时，订单为苏宁采购单，不允许操作破损
            if (this.operateType === '02' && val === 'OFC_SUNING') {
                this.signTableFieldIsEdit.packageDamagedCount = false;
            }
        },
        tableDataList: {
            handler (val) {
                this.initTableData();
            },
            deep: true,
            immediate: true
        }
    }

};
</script>
<style lang="less">
.performanceSignInTable {
    .customTableColumnInput {
        .el-input__inner {
            border-color: transparent;
            cursor: default;
            &:focus {
                border-color: #c3c7c7;
            }
        }
    }
    .el-input {
        vertical-align: middle;
    }
    .notEdit {
        height: 28px;
        line-height: 28px;
    }
}
</style>
